var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3932_44916)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.4613 6.66667C14.2954 6.19603 13.9925 5.7858 13.5915 5.48878C13.1905 5.19176 12.7098 5.02153 12.2113 5H8.87793C8.21489 5 7.579 5.26339 7.11016 5.73223C6.64132 6.20107 6.37793 6.83696 6.37793 7.5C6.37793 8.16304 6.64132 8.79893 7.11016 9.26777C7.579 9.73661 8.21489 10 8.87793 10H12.2113C12.8743 10 13.5102 10.2634 13.979 10.7322C14.4479 11.2011 14.7113 11.837 14.7113 12.5C14.7113 13.163 14.4479 13.7989 13.979 14.2678C13.5102 14.7366 12.8743 15 12.2113 15H8.87793C8.37938 14.9785 7.89869 14.8082 7.4977 14.5112C7.09672 14.2142 6.7938 13.804 6.62793 13.3333",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5449 2.5V5M10.5449 15V17.5",
    stroke: "#2D3643",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3932_44916"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.544922)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.90a3a58204af5a0a5eef141d1b99b42e.svg";
export { ForwardRef as ReactComponent };